import React from "react";
import { Link } from "react-router-dom";
import { VideoCameraIcon } from "@heroicons/react/24/solid";
import cardBackground from "../images/card-background.png";

function VideoCard({ video }) {
  return (
    <Link
      to={`/video/${video.id}`}
      className="block w-full bg-white rounded-lg overflow-hidden hover:border-gray-400 transition-colors duration-300 relative h-full flex flex-col focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
    >
      {/* Top section - Cover image */}
      <div className="h-64 bg-gray-200 flex items-center justify-center overflow-hidden relative">
        {/* Video type pill indicator */}
        <div className="absolute bottom-3 right-3 z-10 group">
          <span className="sr-only">Video</span>
          <div
            className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center shadow-lg"
            aria-hidden="true"
          >
            <VideoCameraIcon className="w-5 h-5 text-white" />
          </div>
          <div
            className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-primary-500 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none"
            aria-hidden="true"
          >
            Video
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-transparent border-t-primary-500"></div>
          </div>
        </div>
        {video.cover_image ? (
          <img
            src={video.cover_image}
            alt={video.title || "Video cover"}
            className="w-full h-full object-cover absolute inset-0"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : null}

        {/* Placeholder (shown if no cover_image or if image fails to load) */}
        <div
          className={`text-gray-500 text-center ${
            video.cover_image ? "hidden" : "flex"
          } items-center justify-center w-full h-full`}
        >
          <div>
            <svg
              className="w-16 h-16 mx-auto mb-2"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-sm">Video</p>
          </div>
        </div>
      </div>

      {/* Bottom section - Text with background image */}
      <div
        className="p-5 pt-3 pb-2 rounded-b-lg flex-1 flex flex-col"
        style={{
          backgroundImage: `url(${cardBackground})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
        }}
      >
        <h3 className="text-xl font-bold text-gray-900 mb-1">
          {video.title || "No title"}
        </h3>
        <div className="flex-1 flex flex-col flex-start">
          <div className="border-b border-gray-300 mt-2 mb-2"></div>
          <p className="text-sm text-gray-600 font-light tracking-wide uppercase mb-1">
            {video.units && Array.isArray(video.units)
              ? video.units.join(", ")
              : "No units specified"}
          </p>
        </div>
      </div>
    </Link>
  );
}

export default VideoCard;
